/**
 * Icon — Material Symbols Outlined wrapper.
 *
 * Centralizes the `material-symbols-outlined` class + fill axis so views
 * don't repeat the span boilerplate. `fill` switches to the filled glyph
 * variant (used for active/selected states in the Stitch mockups).
 */
interface IconProps {
  name: string;
  fill?: boolean;
  className?: string;
  title?: string;
}

export default function Icon({ name, fill, className, title }: IconProps) {
  return (
    <span
      aria-hidden={!title}
      title={title}
      className={[
        'material-symbols-outlined',
        fill ? 'fill' : '',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {name}
    </span>
  );
}
